"use client";

import React, { useRef } from "react";

import { useGSAP } from "@gsap/react";
import gsap from "gsap";

import styles from "@/components/common/QuizBanner/QuizBanner.module.scss";
import WavesSlider from "@/components/common/QuizBanner/WaveSlider";
import Picture from "@/components/ui-kit/Picture/Picture";
import { cn } from "@/utils/general";

const causes = [
  {
    id: "stress",
    name: "Stress",
    value: 5,
  },
  {
    id: "nutrition",
    name: "Nutrition",
    value: 5,
  },
  {
    id: "lifestyle",
    name: "Lifestyle",
    value: 5,
  },
  {
    id: "hormones",
    name: "Hormones",
    value: 5,
  },
  {
    id: "metabolism",
    name: "Metabolism",
    value: 5,
  },
  {
    id: "aging",
    name: "Aging",
    value: 5,
  },
];

interface QuizBannerAnimationProps {
  target?: string;
  mode?: string;
  backgroundImage?: string;
}

const QuizBannerAnimation = ({
  target = "stress",
  mode = `regular`,
  backgroundImage = null,
}: QuizBannerAnimationProps) => {
  const animatedBackgroundRef = useRef(null);

  const reorderedCauses = causes.filter((cause) => cause.id !== target);
  const targetCause = {
    ...causes.find((cause) => cause.id === target),
    value: 10,
  };
  if (targetCause) {
    reorderedCauses.splice(1, 0, targetCause);
  }

  useGSAP(() => {
    if (!animatedBackgroundRef.current) return;

    gsap.to(animatedBackgroundRef.current, {
      filter: "blur(50px)",
      scrollTrigger: {
        trigger: animatedBackgroundRef.current,
        start: "top center",
        end: "center center",
        scrub: 1,
        pinnedContainer: "#growth-pin-wrapper",
        invalidateOnRefresh: true,
      },
    });
  });

  return (
    <div className="h-full">
      {backgroundImage ? (
        <Picture
          ref={animatedBackgroundRef}
          src={backgroundImage}
          alt="Root Causes"
          className=" absolute left-0 top-0 w-full h-full object-cover will-change-[filter]"
          role={`presentation`}
        />
      ) : null}
      <div
        className={cn(
          styles.animatedOverlay,
          "w-full h-full py-[60px] pb-[50px] lg:py-[30px] lg:pt-[30px] lg:pb-0"
        )}
      >
        <WavesSlider causes={reorderedCauses} mode={mode} />
      </div>
    </div>
  );
};

export default QuizBannerAnimation;
